import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import axiosConfig from "../../axiosConfig";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function App(props) {
  const [stripePromise, setStripePromise] = useState();

  useEffect(() => {
    const fetchData = async () => {
      axiosConfig
        .get("/brand/stripe/getPK")
        .then((res) => {
          // console.log("pK ", res.data.key);
          setStripePromise(res.data.key);
        })
        .catch((error) => {
          // console.log("Error in api ", error);
          // console.log("Error in api ", error.response);
        });
    };
    fetchData();
  }, []);

  const paymentResult = (result) => {
    props.paymentResult(result);
  };

  return stripePromise ? (
    <Elements stripe={loadStripe(stripePromise)}>
      <CheckoutForm
        sendPlan={props.planId}
        paymentResult={paymentResult.bind(this)}
      />
    </Elements>
  ) : (
    <CircularProgress style={{ color: "#F6277F" }} />
  );
}
